import {useCallback, useEffect, useState} from "react";
import useEmblaCarousel from "embla-carousel-react";

export const useCarousel = (options) => {
    const [carouselRef, emblaApi] = useEmblaCarousel(options);
    const [selected, setSelected] = useState(0);
    const [snaps, setSnaps] = useState([]);

    const scrollTo = useCallback((i) => {
        emblaApi?.scrollTo(i);
    }, [emblaApi]);

    const prev = useCallback(() => {
        emblaApi?.scrollPrev();
    }, [emblaApi]);

    const next = useCallback(() => {
        emblaApi?.scrollNext();
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;

        const onInit = () => {
            setSnaps(emblaApi.scrollSnapList());
            setSelected(emblaApi.selectedScrollSnap());
        };

        const onSelect = () => {
            setSelected(emblaApi.selectedScrollSnap());
        };

        onInit();

        emblaApi.on('reInit', onInit);
        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('reInit', onInit);
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi]);

    return {
        carouselRef,
        scrollTo,
        prev,
        next,
        selected,
        snaps,
    };
};
